var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEarnAccount = function SvgEarnAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.727 2.957a.625.625 0 0 0 .759.454 6.93 6.93 0 0 1 7.822 3.493 6.876 6.876 0 0 1-2.012 8.38.625.625 0 1 0 .765.989 8.126 8.126 0 0 0 2.36-9.939 8.18 8.18 0 0 0-9.24-4.136.625.625 0 0 0-.454.759",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.318 12.739a.625.625 0 0 0-.544.696l.299 2.43a.625.625 0 0 0 1.24-.152l-.298-2.43a.625.625 0 0 0-.697-.544",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.075 15.882c.05.341.369.577.71.526l2.505-.373a.625.625 0 0 0-.184-1.237l-2.505.373a.625.625 0 0 0-.526.71M12.359 16.867a.625.625 0 0 0-.759-.454 6.93 6.93 0 0 1-7.822-3.493A6.875 6.875 0 0 1 5.79 4.54a.625.625 0 1 0-.765-.989 8.126 8.126 0 0 0-2.36 9.939 8.184 8.184 0 0 0 9.24 4.136.625.625 0 0 0 .454-.759",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.767 7.085a.625.625 0 0 0 .544-.696l-.298-2.43a.625.625 0 0 0-1.24.152l.298 2.43a.625.625 0 0 0 .696.544",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.01 3.942a.625.625 0 0 0-.71-.526l-2.504.373a.625.625 0 0 0 .184 1.237l2.505-.373a.625.625 0 0 0 .526-.71M7.525 11.275a.625.625 0 1 1-.884-.884l2.084-2.083a.625.625 0 0 1 .884 0L11.25 9.95l1.641-1.64a.625.625 0 0 1 .884.883l-2.083 2.083a.625.625 0 0 1-.884 0L9.167 9.634z",
    clipRule: "evenodd"
  })));
};
export default SvgEarnAccount;